import React from "react";
import Modal from "react-modal";
//assets
import icon_close__white from "../../assets/icons/icon-close--white.svg";
import { useSubscriptionContext } from "../../context/providers/SubscriptionContext";

const RemoveCard = ({ activeModal, closeModal, modalStylesReset, subscription, user }) => {
	const { cancelSubscription } = useSubscriptionContext();
	const handleClick = (e) => {
		e.preventDefault();
		closeModal();
		cancelSubscription(subscription._id);
	};
	return (
		<Modal isOpen={activeModal === "DeleteCardModal"} onRequestClose={closeModal} style={modalStylesReset}>
			<div className="modal__content modal--card container--default d-flex flex-column justify-content-center p-3 p-md-4">
				<button className="btn btn--empty modal__close p-4" onClick={closeModal}>
					<img src={icon_close__white} alt="" />
				</button>
				<div>
					<h2 className="modal__title text-center pt-5 mt-3">Are you sure you want to delete your card?</h2>
					<p className="mt-3">Your subscription will be suspended after the paid period expires.</p>
					<div className="d-flex flex-column align-items-center justify-content-center">
						<button className="btn btn--white w-100 mt-5" onClick={closeModal}>
							No, keep my card
						</button>
						<button className="btn btn--empty w-100 mt-3" onClick={handleClick}>
							Yes, delete my card
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default RemoveCard;
